import { render } from "./MultipleLogo.vue?vue&type=template&id=59043758&scoped=true&ts=true"
import script from "./MultipleLogo.vue?vue&type=script&lang=ts"
export * from "./MultipleLogo.vue?vue&type=script&lang=ts"

import "./MultipleLogo.vue?vue&type=style&index=0&id=59043758&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59043758"]])

export default __exports__